import { DetailsContent } from "../../components/app_layout/DetailsLayout";
import { Flex, Text } from "../../styles/utility-components";

interface BidWritingQuestionsPageProps {
  opportunityId: string;
  bidId?: string;
}

export function BidWritingQuestionsPage({ opportunityId, bidId }: BidWritingQuestionsPageProps) {
  return (
    <DetailsContent>
      <Flex column gap={16}>
        <Text h1>Bid Writing Questions</Text>
        <Text color="textSecondary">
          Opportunity: {opportunityId}
          {bidId && ` | Bid: ${bidId}`}
        </Text>
      </Flex>
    </DetailsContent>
  );
}
